import type { ExpanderListItem } from '@rio-cloud/rio-uikit/ExpanderList';

import { BulkMaterialDetails } from '#components/shared/BulkMaterialDetails.tsx';
import { hasMaterialDeviation } from '#domain/hasDeviation.ts';
import type { Material } from '#domain/Material.ts';

import { CargoMaterialDetails } from './CargoMaterialDetails.tsx';

export const MaterialToExpanderListItem = (
    material: Material,
    index: number,
    isSelected: boolean,
    setSelectedIndex: (stopId?: number) => void
): ExpanderListItem => ({
    id: material.id,
    header: (
        <div>
            {hasMaterialDeviation(material) ? (
                <span className='rioglyph rioglyph-palette text-color-danger text-size-h4 padding-right-10' />
            ) : (
                <span className='rioglyph rioglyph-palette text-color-gray text-size-h4 padding-right-10' />
            )}
            <span>{material.name} </span>
        </div>
    ),
    open: isSelected,
    onOpen: () => setSelectedIndex(index),
    onClose: () => setSelectedIndex(undefined),
    bodyClassName: 'padding-top-0',
    body: getBody(material),
});

const getBody = (material: Material) => {
    switch (material.type) {
        case 'cargo-material':
            return <CargoMaterialDetails material={material} />;
        case 'bulk-material':
            return <BulkMaterialDetails material={material} />;
    }
};
